import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useAuth } from "../../context/authContext";
export default () => {
  const { isLoggedIn, logout } = useAuth();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [islogout, setIslogout] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isActive = (path) => location.pathname === path;
  return {
    isLoggedIn,
    setIslogout,
    setIsNavOpen,
    isActive,
    isNavOpen,
    navigate,
    islogout,
    dispatch,
    logout,
  };
};
